import { hasDisplayTotal } from './displayedPrice';
import { hasMarkupAboveTotal } from './finalPricing';
import { isFinalPriceVariantActive } from './finalPriceExperimentReader';

/**
 * Whether an event about these trips reports the markup-inclusive ("final") price (BOOK-168).
 *
 * Read at event time -- once per click, redirect or list, never per trip -- with the rule and tab
 * latch the cards use, so the reported arm is the painted one. Gated on the trips' own `pricing`,
 * the object `seen_price` and analytics `Price` are read from: a trip or list without a companion
 * above its total never reaches GrowthBook.
 *
 * It lives beside `finalPriceExperimentReader` rather than inside it, so suites that mock the
 * reader keep driving this gate through their mock.
 *
 * @param {Array<object>} trips - The plain-JS trips the event reports.
 * @param {object} [options] - The event's context.
 * @param {boolean} [options.isExchange] - Whether the flow is an exchange, which never enters the
 *   final arm.
 * @returns {boolean} Whether to report the final price.
 */
const reportsFinalPrice = (trips, { isExchange } = {}) => {
  const hasMarkup = trips.some((trip) => hasMarkupAboveTotal(trip?.pricing));

  return (
    hasMarkup &&
    isFinalPriceVariantActive({
      hasMarkup,
      hasDisplayTotal: trips.some((trip) => hasDisplayTotal(trip?.pricing)),
      isExchange,
    })
  );
};

export default reportsFinalPrice;
